import { SWR_KEYS } from '@bulknutrients/bulk-shared-lib/constants';
import { boot, shutdown } from '@intercom/messenger-js-sdk';
import { useRouter } from 'next/router';
import { useSWRConfig } from 'swr';

const logout = async (body) =>
  fetch('/api/customer/logout', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

export function useLogout(redirectTo?: string) {
  const { mutate } = useSWRConfig();
  const router = useRouter();
  const body =
    redirectTo && typeof redirectTo === 'string' ? { redirectTo } : {};

  return async () => {
    const response = await logout(body);

    if (response.status !== 200) {
      return false;
    }
    shutdown();
    boot({
      app_id: process.env.NEXT_PUBLIC_INTERCOM_APP_ID as string,
      region: 'ap',
    });
    mutate(SWR_KEYS.customer);
    mutate(SWR_KEYS.alerts);
    mutate(SWR_KEYS.wishlist);

    const path = router.asPath.split('?')[0];
    if (path === '/account' || path.startsWith('/account/')) {
      await router.replace('/');
    }

    return true;
  };
}
